import { put, takeLatest, all, select } from 'redux-saga/effects';
import { API_URL } from 'containers/App/constants';
import { GET_SERVICES } from './constants';
import { servicesLoaded, servicesError, setProductServices } from './actions';
import { SET_OFFER_PRODUCT } from '../OfferValue/constants'
import { makeSelectProduct, makeSelectBroker } from '../OfferValue/selectors';
import { getRequestHeadersAsLogged, responseHandler } from '../../utils/auth';

function* fetchServices() {
  const requestURL = `${API_URL}services`;

  try {
    const parameters = {
      method: 'GET',
      headers: getRequestHeadersAsLogged(),
    };

    const request = yield fetch(requestURL, parameters).then(response =>
      responseHandler(response)
    );

    yield put(servicesLoaded(request.data));
  } catch (err) {
    yield put(servicesError(err));
    console.log('request error', err);
  }
}

function* fetchProductServices() {
  const selectedProduct = yield select(makeSelectProduct());
  const selectedBroker = yield select(makeSelectBroker());

  if (selectedProduct) {
    const requestURL = `${API_URL}services/${selectedProduct}/${selectedBroker}`;

    try {
      const parameters = {
        method: 'GET',
        headers: getRequestHeadersAsLogged(),
      };

      const response = yield fetch(requestURL, parameters).then(response =>
        responseHandler(response)
      );

      if (response && response.data) {
        yield put(setProductServices(response.data));
      }
    } catch (err) {
      console.log('request error', err);
    }
  }
}


function* actionWatcher() {
  yield takeLatest(GET_SERVICES, fetchServices);
  yield takeLatest(SET_OFFER_PRODUCT, fetchProductServices);
}

export default function* servicesData() {
  yield all([actionWatcher()]);
}
